import { render } from "./AssideMenu.vue?vue&type=template&id=6b8aee85&scoped=true"
import script from "./AssideMenu.vue?vue&type=script&lang=js"
export * from "./AssideMenu.vue?vue&type=script&lang=js"

import "./AssideMenu.vue?vue&type=style&index=0&id=6b8aee85&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8aee85"]])

export default __exports__